export function assignLocation(url: string): void {
  window.location.assign(url)
}
